import { INotification } from 'interfaces';

const parseJson = (str?: string) => {
  if (!str) return null;
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
};

export const parseNotificationDeeplink = (
  notification: INotification
): string | null => {
  const parsedData = parseJson(notification.data);

  const deeplink = parsedData?.deeplink;

  return typeof deeplink === 'string' && deeplink ? deeplink : null;
};
